import {
  INTERVIEWS_SET_TYPE,
  INTERVIEWS_SET_FILTERS,
  INTERVIEWS_CLEAR_FILTERS,
  INTERVIEWS_SET_PAGE,
  INTERVIEWS_SET_PAGE_SIZE,
  INTERVIEWS_SET_SEARCH,
  INTERVIEWS_SET_SORT,
  INTERVIEWS_FETCH_REQUEST,
  INTERVIEWS_FETCH_SUCCESS,
  INTERVIEWS_FETCH_FAILURE,
} from '../actions/actionTypes';
import { InterviewsAction } from '../actions/interviewsActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface InterviewsState {
  interviewType: string;
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: InterviewsState = {
  interviewType: '',
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function interviewsReducer(
  state: InterviewsState = initialState,
  action: InterviewsAction,
): InterviewsState {
  switch (action.type) {
    case INTERVIEWS_SET_TYPE:
      // `exceptionBucket` is a view-only cohort (e.g. Behavioral "Skipped R1") with no chip or drawer
      // field: never carry it to the other list, where it would filter silently.
      return {
        ...state,
        interviewType: action.payload,
        filters: action.payload !== state.interviewType && state.filters.exceptionBucket
          ? { ...state.filters, exceptionBucket: undefined }
          : state.filters,
        pagination: { ...state.pagination, page: 1 },
      };
    case INTERVIEWS_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case INTERVIEWS_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case INTERVIEWS_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case INTERVIEWS_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case INTERVIEWS_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case INTERVIEWS_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case INTERVIEWS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case INTERVIEWS_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case INTERVIEWS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
